'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalizableMessage = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _LocalizableMessageShape = require('./LocalizableMessageShape');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  "LocalizableMessage" is a component used in cases where the "message" prop can be either a
  "FormattedMessage" properties object or a plain string.

  `LocalizableMessage` takes the `id`, `defaultMessage` and `values` props used in `FormattedMessage` through it's `message` prop.
  It can also take a `tagName` prop to display the string wrapped in the tag, similar to `FormattedMessage`.
  If a `tagName` prop is not provided it uses "span" (like as how `FormattedMessage` does it).

  Example Usage:

  // Localized Message Object:

  const msg = {
    id: 'example',
    defaultMessage: 'Welcome',
  };

  <LocalizableMessage
      message={msg}
      tagName="a"
  /> === <FormattedMessage id="example" defaultMessage="Welcome" tagName="a" />

  // Inline String

  const msg = 'Welcome'

    <LocalizableMessage
      message={msg}
      tagName="a"
  /> === <a>Welcome</a>

  Extended documentation on usage can be found in the i18n docs
  (https://docs.classpass.engineering/guilds/web/i18n/#displaying-conditional-inline-strings)
*/
var LocalizableMessage = function LocalizableMessage(_ref) {
  var message = _ref.message,
      props = (0, _objectWithoutProperties3.default)(_ref, ['message']);

  var tag = props.tagName || 'span';

  if ((typeof message === 'undefined' ? 'undefined' : (0, _typeof3.default)(message)) === 'object') {
    return _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, props, message));
  }

  if (props.children) {
    return props.children(message);
  }

  return _react2.default.createElement(tag, {}, message);
};

exports.LocalizableMessage = LocalizableMessage;
LocalizableMessage.propTypes = {
  children: _propTypes2.default.func,
  message: _LocalizableMessageShape.LocalizableMessageShape.isRequired,
  tagName: _propTypes2.default.string
};